import React from 'react';
import { IApiService, PagingRequest } from './base';
import { ListItems } from './api';
import { EstimateCommissionRequest, ListCommissionRecipientsRequest,
  ListCommissionsRequest } from './commissions/requests';
import { ICommission, ICommissionRecipient, IEstimateCommissions,
  IEstimateCommissionsRequest } from './commissions/interfaces';

type AllowedExpands = 'agreement' | 'items';

export interface ICommissionService {
  listCommissions(
    pageParams: PagingRequest,
    searchValue?: string,
    expand?: AllowedExpands[],
  ): Promise<ListItems<ICommission>>;
  listCommissionRecipients(
    pageParams: PagingRequest,
    searchValue?: string,
    expand?: AllowedExpands[],
  ): Promise<ListItems<ICommissionRecipient>>;
  estimateCommissions(
    data: IEstimateCommissionsRequest,
  ): Promise<IEstimateCommissions>;
}

export class CommissionService implements ICommissionService {
  protected api: IApiService;

  constructor( api: IApiService ) {
    this.api = api;
  }

  async listCommissions(
    pageParams: PagingRequest,
    searchValue?: string,
    expand?: AllowedExpands[],
  ): Promise<ListItems<ICommission>> {
    const response = await this.api.request( new ListCommissionsRequest( pageParams, searchValue, expand ) );

    return response;
  }

  async listCommissionRecipients(
    pageParams: PagingRequest,
    searchValue?: string,
    expand?: AllowedExpands[],
  ): Promise<ListItems<ICommissionRecipient>> {
    const response = await this.api.request( new ListCommissionRecipientsRequest( pageParams, searchValue, expand ) );

    return response;
  }

  async estimateCommissions(
    data: IEstimateCommissionsRequest,
  ): Promise<IEstimateCommissions> {
    const response = await this.api.request( new EstimateCommissionRequest( data ) );

    return response;
  }
}

export const CommissionServiceContext: React.Context<ICommissionService> = React.createContext( undefined as any );

export const useCommissionService = (): ICommissionService => {
  return React.useContext( CommissionServiceContext );
};
